// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:15:53

export default {
  "id": "pool-8-3",
  "slug": "pool-8-3",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/46e8360b2d194ffabcc00cbb1699e7c8-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/46e8360b2d194ffabcc00cbb1699e7c8/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Pool 8",
      "description": "Pool 8 is a relaxing yet challenging billiards-style puzzle game where players must sink all the balls into the pockets in the correct order. The game follows a step-by-step movement system, requiring strategic planning to clear the table efficiently. With smooth mechanics and progressively difficult levels, Pool 8 offers a unique twist on classic pool gameplay, perfect for puzzle and strategy lovers.  ",
      "instructions": "1. Swipe to move the cue ball in a straight line.  \n2. Plan your moves carefully—balls can only be pocketed in a specific order.  \n3. Use walls to change direction if necessary.  \n4. Clear the table by sinking all balls correctly.  \n5. Think ahead and strategize to complete each level efficiently!",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "8ball",
        "billiard",
        "sliding-puzzle"
      ]
    },
    "zh-CN": {
      "title": "8球台球",
      "description": "8号球是一款轻松却又充满挑战的台球风格益智游戏，玩家必须按照正确的顺序将所有球打入袋中。游戏遵循一步步移动系统，需要战略规划以高效清理桌面。凭借流畅的机制和逐渐增加难度的关卡，Pool 8为经典台球游戏带来了独特的新意，非常适合益智和策略爱好者。",
      "instructions": "1. 拖动杆球使其沿直线移动。\n2. 仔细规划你的走位——球只能按照特定顺序入袋。\n3. 如有必要，使用墙壁改变方向。\n4. 通过正确地将所有球入袋来清台。\n5. 事先思考并制定策略，高效完成每个关卡！",
      "genres": [
        "谜题"
      ],
      "tags": [
        "八球",
        "台球",
        "滑动拼图"
      ]
    },
    "zh-TW": {
      "title": "八人桌式球桌遊戲",
      "description": "Pool 8 是一款輕鬆卻挑戰性十足的撞球風格拼圖遊戲，玩家必須按照正確的順序將所有球打入籃中。遊戲採用步驟式移動系統，需要策略規劃來有效清空桌子。擁有順暢的機制和逐漸升級的難度，Pool 8 帶來了經典撞球遊戲的新鮮風味，完美適合拼圖和策略愛好者。",
      "instructions": "1. 擦拭移動母球沿直線移動。\n2. 計劃您的動作要謹慎——球只能按照特定順序進行入袋。\n3. 如有必要，使用牆壁來改變方向。\n4. 正確將所有球入袋以清潔桌面。\n5. 預先思考並策略性地完成每個關卡！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "八球",
        "桌球",
        "滑動拼圖"
      ]
    },
    "zh-HK": {
      "title": "波八",
      "description": "Pool 8 為一款舒適而富挑戰性的撞球風格謎題遊戲，玩家須依正確順序將所有球打入洞中。遊戲採用一步步移動系統，需要策略規劃以有效地清潔桌面。遊戲具有流暢的操作和逐漸增加的難度等級，為經典撞球遊戲帶來獨特轉變，適合愛好謎題與策略的人士。",
      "instructions": "1. 滑動以直線移動主球。\n2. 謹慎計劃每一步，球只能按照特定順序入袋。\n3. 如有必要，利用牆壁改變方向。\n4. 正確將所有球入袋以清潔桌面。\n5. 高瞻遠矚，制定策略以高效完成每關！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "八球",
        "保龄球",
        "滑動拼圖"
      ]
    },
    "ja": {
      "title": "プール8",
      "description": "プール8はリラックスしながらも挑戦的なビリヤード風パズルゲームで、プレイヤーはボールを正しい順番でポケットにスイングしなくてはなりません。ゲームは一つずつ動きを進めるシステムに従い、テーブルを効率的にクリアするための戦略的な計画が必要です。スムーズなメカニクスと徐々に難易度が上がるレベルで、クラシックなプールプレイにユニークな要素を加え、パズルと戦略の愛好家に最適です。",
      "instructions": "1. スライドしてカウントボールを直線に移動させます。\n2. 動作を慎重に計画してくださいーボールは特定の順番でしかポケットできません。\n3. 必要に応じて壁を使って方向を変えます。\n4. 全てのボールを正しくスinkingしてテーブルをクリアします。\n5. 各レベルを効率的に完了するためには、事前に考え、戦略を立ててください！",
      "genres": [
        "パズル"
      ],
      "tags": [
        "8ball",
        "ビリヤード",
        "スライディングパズル"
      ]
    },
    "ko": {
      "title": "풀 8",
      "description": "파우더 8은 편안하면서도 도전적인 볼링 스타일의 퍼즐 게임으로, 플레이어가 모든 볼을 정확한 순서로 팁에 넣어야 합니다. 게임은 단계별 이동 시스템을 따르며, 테이블을 효율적으로 청소하기 위한 전략적 계획이 필요합니다. 원활한 기계적 구조와 점진적으로 어려워지는 레벨로, 파우더 8은 전통적인 볼링 게임에 독특한 변신을 가미하여 퍼즐과 전략爱好자에게 적합합니다.",
      "instructions": "1. 쿼즈볼을 일직선으로 이동시키기 위해 스와이프하세요.\n2. 신중하게 움직임을 계획하세요 - 볼들은 특정 순서로만 잡을 수 있습니다.\n3. 필요에 따라 벽을 사용하여 방향을 바꿔보세요.\n4. 모든 볼을 올바르게 잡아 테이블을 비우세요.\n5. 각 레벨을 효율적으로 완료하기 위해 미리 생각하고 전략을 세우세요!",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "8볼",
        "빌리어드",
        "슬라이딩 파ズل"
      ]
    },
    "fr": {
      "title": "Boule de billard 8",
      "description": "Pool 8 est un jeu de puzzle au billard relaxant mais délicat où les joueurs doivent faire tomber toutes les billes dans les poches dans le bon ordre. Le jeu suit un système de mouvement étape par étape, nécessitant une planification stratégique pour nettoyer la table efficacement. Avec des mécanismes fluides et des niveaux de plus en plus difficiles, Pool 8 propose une version unique du gameplay classique du billard, parfait pour les amateurs de puzzles et de stratégie.",
      "instructions": "1. Faites glisser pour déplacer la balle de billard en ligne droite.\n2. Planifiez vos mouvements avec soin — les billes ne peuvent être marquées qu'en un ordre spécifique.\n3. Utilisez les murs pour changer de direction si nécessaire.\n4. Videz le tableau en marquant correctement toutes les billes.\n5. Anticipez et stratégisez pour terminer chaque niveau efficacement !",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "8ball",
        "billard",
        "puzzle glissant"
      ]
    }
  }
};
